(function () {

  if (window.__yuaiaSwitchToSubscriptionBound) {
    return;
  }
  
  window.__yuaiaSwitchToSubscriptionBound = true;

  // ── Inline plan-picker helpers ──────────────────────────────────────────────

  function getPlanPicker(button) {
    return button.parentElement.querySelector('.sss-plan-picker');
  }

  function removePlanPicker(button) {
    if (button && button.parentElement) {
      const existing = getPlanPicker(button);
      if (existing) existing.remove();
    }
  }

  function buildPlanPicker(button, planIds, planNames, onConfirm, currentPlanId) {
    removePlanPicker(button);

    // Transform plan names ONLY for hair vitamins product
    const displayPlanNames = isHairVitaminsProduct(button)
      ? transformPlanNamesForHairVitamins(planNames, button)
      : planNames;

    const wrapper = document.createElement('div');
    wrapper.className = 'sss-plan-picker';
    wrapper.style.cssText = [
      'position:relative',
      'display:flex',
      'align-items:center',
      'margin-top:10px',
      'width:100%',
      'background-color:#FBEAEE',
      'border-radius:30px'
    ].join(';');

    const label = document.createElement('span');
    label.textContent = 'Abonnement:';
    label.style.cssText = [
      'flex-shrink:0',
      'padding:10px 6px 10px 14px',
      'font-size:14px',
      'font-weight:700',
      'color:#000',
      'pointer-events:none',
      'white-space:nowrap'
    ].join(';');

    const select = document.createElement('select');
    select.style.cssText = [
      'flex:1',
      'min-width:0',
      'padding:10px 32px 10px 4px',
      'background:transparent',
      'color:#000',
      'border:none',
      'font-size:14px',
      'font-weight:400',
      'font-family:inherit',
      'cursor:pointer',
      'appearance:none',
      '-webkit-appearance:none',
      'outline:none',
      'line-height:1.4'
    ].join(';');

    const prompt = document.createElement('option');
    prompt.value = '';
    prompt.textContent = 'Vælg forbrug';
    prompt.disabled = true;
    prompt.selected = !currentPlanId;
    select.appendChild(prompt);

    planIds.forEach(function (id, i) {
      const option = document.createElement('option');
      option.value = id;
      option.textContent = displayPlanNames[i] || id;
      if (currentPlanId && id === currentPlanId) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    select.addEventListener('change', async function () {
      const selectedId = Number(this.value);
      if (!selectedId) return;

      const selectedIndex = planIds.indexOf(selectedId);
      const selectedPlanName = planNames[selectedIndex] || '';
      const productHandle = button.dataset.productHandle || (window.Shopify?.product?.handle) || null;

      let variantIdForPlan = null;
      if (isHairVitaminsProduct(button) && productHandle) {
        variantIdForPlan = await getVariantIdForPlan(productHandle, selectedPlanName, button);
      }

      const finalVariantId = isHairVitaminsProduct(button) 
        ? (variantIdForPlan || Number(button.dataset.variantId || 0))
        : Number(button.dataset.variantId || 0);
      
      wrapper.replaceWith(createLoadingPill());
      onConfirm(selectedId, finalVariantId);
    });

    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.style.cssText = [
      'position:absolute',
      'right:14px',
      'top:12px',
      'pointer-events:none',
      'font-size:24px',
      'color:#000',
      'line-height:1',
      'height:15px'
    ].join(';');
    arrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M4 6L8 10L12 6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    wrapper.appendChild(arrow);

    button.insertAdjacentElement('afterend', wrapper);
    return wrapper;
  }

  function buildPlanPickerForDiv(element, planIds, planNames, onConfirm, currentPlanId) {
    // Verify element still exists in DOM and has data
    if (!element || !element.parentElement || !document.contains(element)) {
      console.warn('[SwitchToSubscription] ⚠️ Element not in DOM or removed, skipping picker build');
      return null;
    }

    const existing = element.querySelector('.sss-plan-picker');
    if (existing) existing.remove();

    const displayPlanNames = isHairVitaminsProduct(element)
      ? transformPlanNamesForHairVitamins(planNames, element)
      : planNames;

    const wrapper = document.createElement('div');
    wrapper.className = 'sss-plan-picker';
    wrapper.style.cssText = [
      'position:relative',
      'display:flex',
      'align-items:center',
      'width:100%',
      'margin-top:10px',
      'background-color:#FBEAEE',
      'border-radius:30px'
    ].join(';');

    const label = document.createElement('span');
    label.textContent = 'Abonnement:';
    label.style.cssText = [
      'flex-shrink:0',
      'padding:10px 6px 10px 14px',
      'font-size:14px',
      'font-weight:700',
      'color:#000',
      'pointer-events:none',
      'white-space:nowrap'
    ].join(';');

    const select = document.createElement('select');
    select.style.cssText = [
      'flex:1',
      'min-width:0',
      'padding:10px 32px 10px 4px',
      'background:transparent',
      'color:#000',
      'border:none',
      'font-size:14px',
      'font-weight:400',
      'font-family:inherit',
      'cursor:pointer',
      'appearance:none',
      '-webkit-appearance:none',
      'outline:none',
      'line-height:1.4'
    ].join(';');

    const prompt = document.createElement('option');
    prompt.value = '';
    prompt.textContent = 'Vælg forbrug';
    prompt.disabled = true;
    prompt.selected = !currentPlanId;
    select.appendChild(prompt);

    planIds.forEach(function (id, i) {
      const option = document.createElement('option');
      option.value = id;
      option.textContent = displayPlanNames[i] || id;
      if (currentPlanId && id === currentPlanId) {
        option.selected = true;
      }
      select.appendChild(option);
    });

    select.addEventListener('change', async function () {
      const selectedId = Number(this.value);
      if (!selectedId) return;

      const selectedIndex = planIds.indexOf(selectedId);
      const selectedPlanName = planNames[selectedIndex] || '';
      const productHandle = element.dataset.productHandle || (window.Shopify?.product?.handle) || null;

      let variantIdForPlan = null;
      if (isHairVitaminsProduct(element) && productHandle) {
        variantIdForPlan = await getVariantIdForPlan(productHandle, selectedPlanName, element);
      }

      const finalVariantId = isHairVitaminsProduct(element) 
        ? (variantIdForPlan || Number(element.dataset.variantId || 0))
        : Number(element.dataset.variantId || 0);

      wrapper.replaceWith(createLoadingPill());
      onConfirm(selectedId, finalVariantId);
    });

    const arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.style.cssText = [
      'position:absolute',
      'right:14px',
      'top:12px',
      'pointer-events:none',
      'font-size:24px',
      'color:#000',
      'line-height:1',
      'height:15px'
    ].join(';');
    arrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M4 6L8 10L12 6" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

    wrapper.appendChild(label);
    wrapper.appendChild(select);
    wrapper.appendChild(arrow);

    // Clear and append inside the element
    element.innerHTML = '';
    element.appendChild(wrapper);
    return wrapper;
  }

  function createLoadingPill() {
    const loadingPill = document.createElement('div');
    loadingPill.className = 'sss-plan-picker';
    loadingPill.style.cssText = [
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'width:100%',
      'margin-top:10px',
      'background-color:#FBEAEE',
      'border-radius:30px',
      'padding:10px 14px',
      'font-size:14px',
      'font-weight:600',
      'color:#D62E55',
      'gap:8px'
    ].join(';');

    const spinner = document.createElement('span');
    spinner.style.cssText = [
      'display:inline-block',
      'width:14px',
      'height:14px',
      'border:2px solid #D62E55',
      'border-top-color:transparent',
      'border-radius:50%',
      'animation:sss-spin 0.7s linear infinite',
      'flex-shrink:0'
    ].join(';');

    if (!document.getElementById('sss-spinner-style')) {
      const style = document.createElement('style');
      style.id = 'sss-spinner-style';
      style.textContent = '@keyframes sss-spin{to{transform:rotate(360deg)}}';
      document.head.appendChild(style);
    }

    loadingPill.appendChild(spinner);
    loadingPill.appendChild(document.createTextNode('Opdaterer...'));

    return loadingPill;
  }

  // ── Plan name to duration mapping (Hair Vitamins only) ──────────────────────

  function isHairVitaminsProduct(element) {
    const productHandle = element?.dataset?.productHandle;
    if (productHandle === 'yuaia-haarvitaminer') return true;
    if (!productHandle && window.location.pathname === '/products/yuaia-haarvitaminer') return true;
    return false;
  }

  function transformPlanNamesForHairVitamins(planNames, element) {
    if (!isHairVitaminsProduct(element)) {
      return planNames;
    }
    
    return planNames.map(function(name) {
      const normalized = (name || '').toLowerCase();
      if (/\b1\.?\s*m[aå]neds?(?:er)?\b/.test(normalized)) return '1 måneds forbrug';
      if (/\b3\.?\s*m[aå]neds?(?:er)?\b/.test(normalized)) return '3 måneders forbrug';
      if (/\b6\.?\s*m[aå]neds?(?:er)?\b/.test(normalized)) return '6 måneders forbrug';
      return name;
    });
  }

  function getPlanDurationMonths(planName) {
    const normalized = (planName || '').toLowerCase();
    if (/\b1\.?\s*m[aå]neds?(?:er)?\b|\b1\s*month\b|\belke maand\b/.test(normalized)) return 1;
    if (/\b3\.?\s*m[aå]neds?(?:er)?\b|\b3\s*month\b|\belke 3 maanden\b/.test(normalized)) return 3;
    if (/\b6\.?\s*m[aå]neds?(?:er)?\b|\b6\s*month\b|\belke 6 maanden\b/.test(normalized)) return 6;
    return null;
  }

  async function getProductVariants(productHandle) {
    try {
      if (!productHandle) return [];
      const url = '/products/' + encodeURIComponent(String(productHandle)) + '.js';
      const response = await fetch(url);
      if (!response.ok) return [];
      const product = await response.json();
      return product.variants || [];
    } catch (error) {
      return [];
    }
  }

  async function switchToSubscription(element, sellingPlanId, overrideVariantId) {
    if (!element) return;

    if (element.dataset.loading === '1') return;
    element.dataset.loading = '1';

    const lineKey = (element.dataset.lineKey || '').trim();
    const variantId = Number(overrideVariantId || element.dataset.variantId || 0);
    const quantity = Math.max(1, Number(element.dataset.quantity || 1) || 1);
    const planId = Number(sellingPlanId || 0);

    if (!lineKey || !variantId || !planId) {
      element.dataset.loading = '0';
      throw new Error('Missing cart identifiers (lineKey/variantId/sellingPlanId)');
    }

    let properties = {};
    try { properties = JSON.parse(element.dataset.properties || '{}') || {}; } catch (e) {}

    try {
      const addPayload = { id: variantId, quantity: quantity, selling_plan: planId };
      if (properties && Object.keys(properties).length > 0) addPayload.properties = properties;

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(addPayload)
      });
      const addJson = await addResponse.json();

      if (!addResponse.ok || (addJson && addJson.status)) {
        throw new Error((addJson && addJson.description) || 'Unable to add subscription item');
      }

      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });

      if (!removeResponse.ok) throw new Error('Unable to remove one-time item from cart');

      if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
        window.Shopify.onItemAdded(addJson, true);
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: addJson }));
        setTimeout(function() { window.location.reload(); }, 500);
      }
    } finally {
      element.dataset.loading = '0';
    }
  }

  async function getVariantIdForPlan(productHandle, planName, element) {
    if (!isHairVitaminsProduct(element)) {
      return null;
    }

    const targetDuration = getPlanDurationMonths(planName);
    if (!targetDuration) {
      return null;
    }

    const variants = await getProductVariants(productHandle);
    if (!variants.length) {
      return null;
    }

    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i];
      const durationFromTitle = getPlanDurationMonths(variant.title || '');
      
      if (durationFromTitle === targetDuration) {
        return variant.id;
      }
    }

    // Fallback to index-based approach
    const variantIndex = targetDuration === 1 ? 0 : targetDuration === 3 ? 1 : 2;
    const fallbackVariant = variants[variantIndex];
    if (fallbackVariant) {
      return fallbackVariant.id;
    }

    return null;
  }

  // ── Cart add/remove logic ────────────────────────────────────────────────────

  async function switchToSubscription(element, sellingPlanId, overrideVariantId) {
    const lineKey = element.dataset.lineKey;
    const variantId = overrideVariantId || Number(element.dataset.variantId || 0);
    const quantity = Math.max(1, Number(element.dataset.quantity || 1) || 1);

    let properties = {};
    try { properties = JSON.parse(element.dataset.properties || '{}') || {}; } catch (e) {}

    try {
      const addPayload = { id: variantId, quantity: quantity, selling_plan: sellingPlanId };
      if (properties && Object.keys(properties).length > 0) addPayload.properties = properties;

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(addPayload)
      });
      const addJson = await addResponse.json();

      if (!addResponse.ok || (addJson && addJson.status)) {
        throw new Error((addJson && addJson.description) || 'Unable to add subscription item');
      }

      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      });

      if (!removeResponse.ok) throw new Error('Unable to remove one-time item from cart');

      if (window.Shopify && typeof window.Shopify.onItemAdded === 'function') {
        window.Shopify.onItemAdded(addJson, true);
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: addJson }));
        setTimeout(function() { window.location.reload(); }, 500);
      }
    } catch (error) {
      alert('Error: ' + error.message);
    }
  }

  // ── Main click handler ───────────────────────────────────────────────────────

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-switch-subscription]:not([data-is-subscription="true"])');
    if (!button) return;
    
    event.preventDefault();

    if (button.dataset.loading === '1') {
      return;
    }

    const planIds = (button.dataset.sellingPlanIds || '')
      .split(',')
      .map(function (v) { return Number(String(v).trim() || 0); })
      .filter(Boolean);

    const planNames = (button.dataset.sellingPlanNames || '')
      .split('|')
      .map(function (v) { return v.trim(); });

    if (planIds.length > 1) {
      if (getPlanPicker(button)) {
        return;
      }
      button.style.display = 'none';
      const currentPlanId = Number(button.dataset.currentPlanId || 0);
      buildPlanPicker(button, planIds, planNames, function (selectedPlanId, selectedVariantId) {
        switchToSubscription(button, selectedPlanId, selectedVariantId).catch(function (err) {
          removePlanPicker(button);
          button.style.display = '';
        });
      }, currentPlanId);
    } else if (planIds.length === 1) {
      switchToSubscription(button, planIds[0]).catch(function (err) {
        console.error('[SwitchToSubscription] ❌ Single plan error:', err);
      });
    }
  });

  // ── Auto-show picker for subscription items ──────────────────────────────────

  function initSubscriptionPickers() {
    const subscriptionDivs = document.querySelectorAll('div[data-switch-subscription][data-is-subscription="true"]');
    
    subscriptionDivs.forEach(function (element, index) {
      
      setTimeout(function () {
        // Verify element still exists
        if (!document.contains(element)) {
          console.warn('[SwitchToSubscription] ⚠️ Element #' + (index + 1) + ' is no longer in DOM, skipping');
          return;
        }

        // Always rebuild the picker (don't check if it exists, just rebuild it)
        const planIds = (element.dataset.sellingPlanIds || '')
          .split(',')
          .map(function (v) { return Number(String(v).trim() || 0); })
          .filter(Boolean);

        const planNames = (element.dataset.sellingPlanNames || '')
          .split('|')
          .map(function (v) { return v.trim(); });

        if (planIds.length > 0) {
          const currentPlanId = Number(element.dataset.currentPlanId || 0);
          buildPlanPickerForDiv(element, planIds, planNames, function (selectedPlanId, selectedVariantId) {
            switchToSubscription(element, selectedPlanId, selectedVariantId).catch(function (err) {
              console.error('[SwitchToSubscription] ❌ Div picker #' + (index + 1) + ' error:', err);
            });
          }, currentPlanId);
        } else {
          console.warn('[SwitchToSubscription] ⚠️ No plan IDs found for element #' + (index + 1) + ', innerHTML is: "' + element.innerHTML + '"');
        }
      }, 100 + (index * 50)); // Stagger initialization
    });
  }

  // ── Initialize on page load and after cart updates ────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscriptionPickers);
  } else {
    initSubscriptionPickers();
  }

  // Listen for cart:updated event
  document.addEventListener('cart:updated', function() {
    // Cart drawer takes time to re-render, try initialization at multiple intervals
    setTimeout(function() {
      initSubscriptionPickers();
    }, 200);
    setTimeout(function() {
      initSubscriptionPickers();
    }, 400);
    setTimeout(function() {
      initSubscriptionPickers();
    }, 700);
  });

  // Watch for new subscription divs being added to the DOM
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var hasSubscriptionDivs = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            // Check if any added node is or contains a subscription picker div
            if (node.nodeName === 'DIV' && node.getAttribute && node.getAttribute('data-is-subscription') === 'true') {
              hasSubscriptionDivs = true;
            }
            // Also check children
            if (node.querySelectorAll) {
              var found = node.querySelectorAll('div[data-is-subscription="true"]');
              if (found.length > 0) hasSubscriptionDivs = true;
            }
          });
        }
      });
      if (hasSubscriptionDivs) {
        setTimeout(initSubscriptionPickers, 150);
      }
    });

    var cartContainer = document.querySelector('[data-cart-notification]') || 
                        document.querySelector('.cart-drawer') ||
                        document.querySelector('[data-cart-drawer]') ||
                        document.body;
    
    observer.observe(cartContainer, {
      childList: true,
      subtree: true,
      attributes: false
    });
    
  }

  // Periodic check for new subscription items
  var lastCount = 0;
  setInterval(function() {
    var currentCount = document.querySelectorAll('div[data-switch-subscription][data-is-subscription="true"]').length;
    if (currentCount !== lastCount) {
      lastCount = currentCount;
      initSubscriptionPickers();
    }
  }, 500);
})();
